import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './app/components/App';
import TagManager from './app/Helpers/tagManagerHelper';
import { unregister } from './registerServiceWorker';

TagManager.initializeTagManager();

//initialice hotjar params [hjid, hjsv]
//hotjar.initialize(707603, 6);
//Sentry Config
Sentry.init({
    dsn: 'https://69e2631a949c4c1aa0c1706ee297e146@o332279.ingest.sentry.io/1884321',
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
    ignoreErrors: ['google_tag_manager.dataLayer.get is not a function'],
    ignoreUrls: ['https://www.googletagmanager.com']
});
createRoot(document.getElementById('root')).render(<App />);
//registerServiceWorker();
unregister();
